<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <img :src="importedImg2" :alt="altText" class="imgItem2" />
      </div>
    </div>

    <div class="imgBox3 min-w-1400">
      <div class="img3 max-w-1400">
        <img :src="importedImg3" :alt="altText" class="imgItem3" />
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4 max-w-1400">
        <img :src="importedImg4" :alt="altText" class="imgItem4" />
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5 max-w-1400">
        <img :src="importedImg5" :alt="altText" class="imgItem5" />
        <div class="img5_a" @click="gotoOfficialWebsite"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/tamogiefectivo/components/img/2_1.png";
import importedImg2 from "@/page/tamogiefectivo/components/img/2_2.png";
import importedImg3 from "@/page/tamogiefectivo/components/img/2_3.png";
import importedImg4 from "@/page/tamogiefectivo/components/img/2_4.png";
import importedImg5 from "@/page/tamogiefectivo/components/img/2_5.png";
export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      altText: "图片",
    };
  },
  methods:{
    gotoOfficialWebsite() {
      window.open("https://www.kartermax.com", '_blank');
    },
  }
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}
.imgBox1,
.imgBox2,
.imgBox4,
.imgBox5 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
}


.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
}

img {
  display: block;
}
.img1,
.img2,
.img4,
.img5 {
  width: 100%;
  overflow: hidden;
  max-width: 1620px;
  margin-left: 0;
  margin-right: 0;
  justify-content: space-between;
}


.img3 {
  margin-left: 45px;
  margin-right: 45px;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
.imgItem2 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
.imgItem3 {
  max-width: 100%;
  margin-top: 60px;
  margin-bottom: 60px;
}
.imgItem4 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
.imgItem5 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.img3,
.img4{
  padding: 0 240px;
}
.img3{
  margin: 20px 0 40px;
}
.img4{
  margin-bottom: 70px;
}
.img5{
  position: relative;
}
.img5_a{
  position: absolute;
  top:50%;
  left: 15%;
  height: 80px;
  width: 310px;
  cursor: pointer;
  background: transparent;
  /* border: 1px solid red; */
}
</style>
